/** Byte order mark Excel writes ahead of a UTF-8 file. Invisible, and not part of a cell value. */
const BOM = '﻿';

/**
 * The cells of one CSV line, unpadded and unquoted.
 *
 * Deliberately a split rather than a parse, for the same reason `readCsvLines` is: this backs
 * the checks that run before a file is sent anywhere and the tables that show it back, neither
 * of which is the authority on what the file holds. A quoted field containing a comma is
 * therefore seen as two cells, which is acceptable while the templates hold no free text.
 */
export const parseCsvCells = (line: string): string[] =>
  line
    .replace(BOM, '')
    .split(',')
    // A cell may arrive quoted, and either side of it may be padded.
    .map((cell) =>
      cell
        .trim()
        .replace(/^"(.*)"$/, '$1')
        .trim(),
    );
